'use client'

import ArticleCard from "@/components/ArticleCard"
import LoadingSpinner from "@/components/icons/LoadingSpinner"
import { getArticles } from "@/lib/actions/getArticles"
import useInView from "@/lib/hooks/useInView"
import { useEffect, useState } from "react"

interface ArticlesGridProps {
	initialArticles: any
	tag?: string
	totalCount?: number
}

const ARTICLES_PER_PAGE = 12

export default function ArticlesGrid({initialArticles, tag, totalCount}:ArticlesGridProps) {
	const [articles, setArticles] = useState<any>(initialArticles)
	const [offsetStart, setOffsetStart] = useState(ARTICLES_PER_PAGE)
	const [offsetEnd, setOffsetEnd] = useState(ARTICLES_PER_PAGE + ARTICLES_PER_PAGE)
	const [ref, inView] = useInView()

	const loadMoreArticles = async () => {
		const { articles: newArticles } = await getArticles(offsetStart, offsetEnd, tag)
		const allArticles = [...articles, ...(newArticles as any)]
		setArticles(allArticles)
		setOffsetStart(offsetStart + ARTICLES_PER_PAGE)
		setOffsetEnd(offsetEnd + ARTICLES_PER_PAGE)
	}

	useEffect(() => {
		if (inView && articles?.length < totalCount) {
			loadMoreArticles()
		}
	}, [inView])

	return (
		<div className="site-wrapper mb-[3rem] sm:mb-[4rem] md:mb-[8rem] px-site-margin">
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-gutter gap-y-12">{articles?.map((article, index) => <ArticleCard key={`journal-item-${index}`} article={article} />)}</div>
			<div ref={ref} className={`my-[4rem] md:my-[8rem] animate-pulse font-display italic text-center ${articles?.length >= totalCount ? 'hidden' : 'block'}`}>
				<LoadingSpinner className="w-8 h-8" />
			</div>
		</div>
	)
}